import type { NormalizeDurationProps } from './normalizeDuration';
import normalizeDuration from './normalizeDuration';

// TODO: Intl.GetRelativeTimeFormat does not support multi-unit durations, when it does we can easily use that here
const getNormalizedRelativeDuration = (props: NormalizeDurationProps) => {
  let duration;

  try {
    duration = normalizeDuration(props);
  } catch (error) {
    // So we can investigate from our analytics provider later, but not throw
    // eslint-disable-next-line no-console
    console.error(error);
  }

  if (!duration) {
    return undefined;
  }

  if (duration.as('milliseconds') === 0) {
    return 'Just now';
  }

  return `${duration.toHuman({ listStyle: 'narrow' })} ago`;
};

export default getNormalizedRelativeDuration;
